<section>
  <div class="col-lg-3 col-md-4 col-12 mx-auto my-auto">
    <div class="login-logo">
      <img *ngIf="configuracao" [src]="(configuracao.entidade.id | imageEntidade) | async" class="img-size-50"/>
      <h2><b>Folha de <br> Pagamento</b></h2>
    </div>
    <div class="card card-body">
      <p class="login-box-msg">entre para iniciar a sessão</p>

      <form #form="ngForm" (ngSubmit)="login()">
        <app-input icon-left-class="fa fa-user">
          <input type="text" mask="000.000.000-00" class="form-control form-control-sm" input-content name="cpf" placeholder="CPF" [(ngModel)]="usuario.cpf"
            id="inputEmail">
        </app-input>
        <app-input icon-left-class="fa fa-lock">
          <input type="password" class="form-control form-control-sm" input-content name="password" placeholder="Senha" [(ngModel)]="usuario.password"
            id="inputPassword">
        </app-input>
        <div class="text-right">
          <button type="submit" [disabled]="!form.valid" class="btn btn-danger">Entrar</button>
        </div>
      </form>

    </div>
  </div>
  <br /><br /><br /><br />
</section>
<app-message-container></app-message-container>
